import { container } from "tsyringe";
import { SourceService } from "../source.service";

export const getDataSourcesFn = () => {
  const sourceService = container.resolve(SourceService);
  return sourceService.getDataSources();
};
